import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { countryCodes } from '../globals/rm-phone-select-input/countryCodes';
import { StorageService } from '@web-frontend/shared/services/storage/storage.service';
import { RmSelectRegister } from '../globals/rm-select-register/rm-select-register.types';

interface Country {
  code: string;
  name: string;
}

@Component({
  selector: 'roma-add-company-modal',
  templateUrl: './add-company-modal.component.html',
  styleUrls: ['./add-company-modal.component.scss'],
})
export class AddCompanyModalComponent implements OnInit {
  form: FormGroup;
  countryCodes: Country[] = [];
  countryItems: RmSelectRegister.Items = [];
  selectedCountry: RmSelectRegister.Items = [];
  submitted = false;

  constructor(
    public dialogRef: MatDialogRef<AddCompanyModalComponent>,
    private fb: FormBuilder
  ) {
    const preselectedCountry = this.getPreselectedCountryCode();
    this.form = this.fb.group({
      name: ['', Validators.required],
      country: [preselectedCountry, Validators.required],
    });
  }

  ngOnInit(): void {
    this.initCountryCodes();
    this.mapCountriesToSelectItems();
    Promise.resolve().then(() => this.syncSelectedCountry());
  }

  getLang() {
    return StorageService.GetItem('USER_LANG');
  }

  initCountryCodes() {
    const countryC = countryCodes;
    const language = this.getLang();

    this.countryCodes = countryC
      .map((country) => ({
        code: country?.code,
        name: country?.name[language],
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  mapCountriesToSelectItems(): void {
    this.countryItems = this.countryCodes.map((country) => ({
      id: country.code,
      value: country.code,
      title: country.name,
    }));
  }

  private getPreselectedCountryCode(): string {
    try {
      const companyData = StorageService.companyData;
      if (companyData) {
        const parsedData = JSON.parse(companyData);
        return parsedData?.locationCountry || '';
      }
    } catch (error) {
      console.error('Error parsing companyData from localStorage:', error);
    }
    return '';
  }

  syncSelectedCountry(): void {
    const countryValue = this.form.value.country;
    if (countryValue) {
      const match = this.countryItems.find(
        (item) => item.value === countryValue
      );
      if (match) {
        this.selectedCountry = [match];
      }
    }
  }

  onCountryChange(items: RmSelectRegister.Items): void {
    this.selectedCountry = items;
    if (items.length > 0) {
      this.form.patchValue({ country: items[0].value });
    } else {
      this.form.patchValue({ country: '' });
    }
  }

  changeName(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.form.patchValue({ company_name: value });
  }

  exit(): void {
    this.dialogRef.close();
  }

  submit(): void {
    Object.keys(this.form.controls).forEach((key) => {
      this.form.controls[key].markAsTouched();
    });

    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }
}
